"use client";
import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useRouter } from "next/navigation";
import globalAxiosURL from "@/hooks/globalAxiosURL";
import Head from "@/app/head";
import { BiLoaderAlt } from "react-icons/bi";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Register = () => {
  const pageTitle = "Partner Registration ";
  const pageDescription =
    "Registration form for HAMS partner and avail our ammenities ";
  const router = useRouter();
  const axiosURL = globalAxiosURL();
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    agencyName: "",
    mobileNumber: "",
    whatsAppNumber: "",
    businessEmail: "",
    address: "",
    postalCode: "",
    country: "",
    state: "",
    district: "",
    city: "",
    hqCity: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleGoBack = () => {
    router.back();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosURL.post("/agentAuth/register", formData);

      const result = await response.data;
      setSuccess("Registration successful!");
      setLoading(false);
    } catch (err) {
      if (axiosURL.isAxiosError(err)) {
        setError(err.response?.data?.message || "An error occurred");
        setLoading(false);
      } else {
        setError("An error occurred");
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <div className="flex justify-center mt-10">
        <Head title={pageTitle} description={pageDescription} />
        <form
          onSubmit={handleSubmit}
          className="border rounded-xl shadow-lg mt-10 lg:px-10 lg:py-10 md:px-6 md:py-10 px-2 py-2"
        >
          <div className="mt-5">
            <button
              type="button"
              onClick={handleGoBack}
              className="flex gap-1 text-green-600 font-semibold mb-5"
            >
              <FaArrowLeft className="mt-1" />
              Back
            </button>
          </div>
          <h1 className="text-[40px] text-gray-600">Sign Up</h1>
          <br />
          <hr />
          <h1 className="mt-5 lg:text-[30px] md:text-[30px] text-[25px] text-green-600 font-semibold">
            Primary Agent Information
          </h1>
          {/* <p className='text-sm mt-6'>Select Title <span className='text-red-600'>*</span></p>
          <div className='flex gap-2 mt-2'>
          <input type="radio" name='mr' value="transport"/>
          <h1>Mr</h1>
          <input type="radio" name='mrs' value="transport" />
          <h1>Mrs</h1>
          <input type="radio" name='ms' value="transport"/>
          <h1>Ms</h1>
          </div> */}

          <div className="">
            <div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="mt-8 text-sm text-gray-600 font-medium">
                    First Name <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="Enter Your First Name"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Last Name <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Enter Your Last Name"
                    required
                    value={formData.lastName}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Agency or Corporate Name{" "}
                    <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="text"
                    name="agencyName"
                    placeholder="Enter Agency Name"
                    required
                    value={formData.agencyName}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Mobile Number <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="text"
                    name="mobileNumber"
                    placeholder="Enter Mobile Number"
                    required
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    What'sApp Number <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="text"
                    name="whatsAppNumber"
                    placeholder="Enter WhatsApp Number"
                    required
                    value={formData.whatsAppNumber}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Business Email Adress{" "}
                    <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="email"
                    name="businessEmail"
                    placeholder="Enter Business Email Adress"
                    required
                    value={formData.businessEmail}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Address <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="address"
                    name="address"
                    placeholder="Enter Address"
                    required
                    value={formData.address}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Postal Code <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="code"
                    name="postalCode"
                    placeholder="Enter Postal Code"
                    required
                    value={formData.postalCode}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    Country <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="country"
                    name="country"
                    placeholder="Country"
                    required
                    value={formData.country}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    State <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="option"
                    name="state"
                    placeholder="Select An Option"
                    required
                    value={formData.state}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div className="lg:flex md:flex lg:gap-10 md:gap-11">
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    District <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="district"
                    name="district"
                    placeholder="Select"
                    required
                    value={formData.district}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
                <div>
                  <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                    City <span className="text-red-600">*</span>
                  </p>
                  <input
                    type="city"
                    name="city"
                    placeholder="City"
                    required
                    value={formData.city}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                  />
                </div>
              </div>
              <div>
                <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                  Head Quarter City <span className="text-red-600">*</span>
                </p>
                <input
                  type="text"
                  name="hqCity"
                  placeholder="City, Country (ex: Dhaka, Bangladesh)"
                  required
                  value={formData.hqCity}
                  onChange={handleChange}
                  className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
                />
                {/* <p className="text-green-500 font-semibold mt-3 text-sm">
                  Format* : City, Country (ex: Dhaka, Bangladesh)
                </p> */}
              </div>
            </div>

            <div></div>
          </div>

          <div>
            <div className="mt-10">
              <h1 className="text-[30px] font-bold text-green-600">
                Agent Information
              </h1>
              <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                Email <span className="text-red-600">*</span>
              </p>
              <input
                type="email"
                name="email"
                placeholder="Enter Email Adress"
                required
                value={formData.email}
                onChange={handleChange}
                className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md mt-2 px-3 py-3"
              />
            </div>
            <div className="lg:flex md:flex lg:gap-10 md:gap-11">
              <div>
                <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                  Password <span className="text-red-600">*</span>
                </p>
                <div className="relative w-fit flex items-center mt-2">
                  <input
                    type={showPass ? "text" : "password"}
                    name="password"
                    placeholder="Enter Password"
                    required
                    value={formData.password}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md px-3 py-3"
                  />
                  <div
                    onClick={() => setShowPass(!showPass)}
                    className="absolute right-4 text-gray-700 cursor-pointer"
                  >
                    {showPass ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                  </div>
                </div>
              </div>
              <div>
                <p className="lg:mt-8 md:mt-8 mt-5 text-sm text-gray-600 font-medium">
                  Confirm Password <span className="text-red-600">*</span>
                </p>

                <div className="relative w-fit flex items-center mt-2">
                  <input
                    type={showConfirmPass ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Enter Confirm Password"
                    required
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="lg:h-[50px] lg:w-[400px] md:h-[50px] md:w-[300px] w-[350px] border rounded-md px-3 py-3"
                  />
                  <div
                    onClick={() => setShowConfirmPass(!showConfirmPass)}
                    className="absolute right-4 text-gray-700 cursor-pointer"
                  >
                    {showConfirmPass ? (
                      <FiEyeOff size={16} />
                    ) : (
                      <FiEye size={16} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display error or success messages */}
          {error && <p className="text-red-600">{error}</p>}
          {success && <p className="text-green-600">{success}</p>}

          <button className="lg:mt-10 md:mt-10 mt-6 lg:mb-0 md:mb-0 mb-5 items-center rounded-lg bg-green-700 hover:bg-green-600  lg:h-[50px] md:h-[50px] w-full h-[40px]  text-white ">
            {loading ? (
              <BiLoaderAlt size={25} className="animate-spin mx-auto" />
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
      <br />
      <br />
    </div>
  );
};

export default Register;
